<template>
    <div class="card">

        <div class="card-header">
            <h3 class="mb-0" slot="header">{{ title }}</h3>
        </div>

        <div class="card-body px-0 pt-0" v-if="hasFeedback">
            <div v-for="timeslot in timeslots" :key="timeslot.id">

                <div class="row align-items-center pl-4">
                    <div class="col" style="flex: 0 0 80px">
                        <h5 class="mb-0 float-left" style="font-size:1.1rem;font-weight:700">
                            {{ timeslot.time }}
                        </h5>
                    </div>
                    <div class="col pl-0">
                        <h6 class="font-weight-normal text-sm text-uppercase mb-0">
                            {{ timeslot.instructor_summary }}
                        </h6>
                    </div>
                </div>
                <div v-for="feedback in timeslot.feedbacks" :key="feedback.id">
                    <feedback :feedback="feedback" :showAuthor="true" class="m-4" />
                </div>
            </div>
        </div>
        <div class="card-body" v-else>
            {{ $t('dashboard.no-feedback') }}
        </div>
    </div>

</template>

<script>
    import CrudClient from '@trax/classes/CrudClient'
    import Feedback from '../../log/Feedback'

    export default {

        components: {
            Feedback
        },

        props: {

            title: {
                type: String,
                required: true
            },

            session: {
                type: Object,
                required: true
            },
        },

        data() {
            let endpoint = '/socrates/api/front/dashboard/data/context/session/feedbacks'
            let client = new CrudClient(endpoint, {
                session_id: this.session.id,
                all_testers: true,
                attach_to_log: true,
            })
            return {
                endpoint,
                client,
                timeslots: [],
                loaded: false,
            }
        },

        created() {
            this.list()
        },

        computed: {

            hasFeedback() {
                return this.timeslots.length > 0
            },
        },

        methods: {

            list() {
                this.loaded = false
                this.client.list().then(resp => {
                    this.timeslots = resp.data.data
                    this.loaded = true
                })
            }
        }
    }
</script>
